// Generated by Melange

import * as Buhta_cabinet__ButtonPrimary from "../../../components/html/ButtonPrimary.js";
import * as Buhta_components__Text from "../../../../../../packages/components/src/html/Text.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function make(pending) {
  return function (onClose) {
    return function (onSelectCert) {
      const refCert = React.useRef(null);
      return JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx(Buhta_components__Text.H4.make, {
                                        children: "Вход с ЭЦП"
                                      }),
                                  JsxRuntime.jsx("button", {
                                        children: JsxRuntime.jsx("img", {
                                              className: "w-6 h-6",
                                              src: StaticAsset.src("/static/icons/close.svg")
                                            }),
                                        onClick: (function (param) {
                                            Curry._1(onClose, undefined);
                                          })
                                      })
                                ],
                                className: "px-6 py-4 flex justify-between border-b border-gray-main"
                              }),
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx("img", {
                                        alt: "key",
                                        src: StaticAsset.src("/static/icons/key-gray-40.svg")
                                      }),
                                  JsxRuntime.jsx(Buhta_components__Text.H3.make, {
                                        className: "mt-6",
                                        children: "Выберите ключ ЭЦП для подписания"
                                      }),
                                  JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                        className: "mt-2 text-asphalt",
                                        children: "Необходимо подключить модуль Бухта в настройках NCALayer"
                                      }),
                                  JsxRuntime.jsx("div", {
                                        children: JsxRuntime.jsx(Buhta_cabinet__ButtonPrimary.make, {
                                              title: "Выбрать ключ",
                                              onClick: (function (param) {
                                                  Curry._1(onSelectCert, undefined);
                                                }),
                                              reference: refCert,
                                              disabled: pending
                                            }),
                                        className: "mt-6"
                                      })
                                ],
                                className: "flex flex-col items-center pt-10 pb-16"
                              })
                        ],
                        className: "w-120 bg-white rounded shadow-payroll"
                      }),
                  className: "absolute inset-0 bg-black/40 flex justify-center items-center z-10"
                });
    };
  };
}

function NcaLayerSelectCertModal(Props) {
  return Curry._1(make(Props.pending)(Props.onClose), Props.onSelectCert);
}

const make$1 = NcaLayerSelectCertModal;

export {
  make$1 as make,
}
/* Buhta_cabinet__ButtonPrimary Not a pure module */
